import {forEach} from 'ramda';
import bindEvent from '../../scripts/util/bindEvent';
import findClsRemove from '../../scripts/util/findClsRemove';
import isMobile from 'ismobilejs';
import $ from 'jquery';

const selectors = {
	parent: '.js-accordeon',
	target: '.js-accordeon-item',
	quideTarget: '.common-guide .js-accordeon-item',
	wrap: '.js-accordeon-wrap',
	content: '.js-accordeon-content',
	activeGuideSection: '.tabs__tabs-list-section--show',
	commonGuide: '.common-guide',
	quideBlock: '.common-guide__faq',
	guideSidebarItem: '.common-guide__faq .js-faq-menu-fixed .js-list-item'
};

const classes = {
	active: 'accordeon__item_state_active',
	activeWrap: 'accordeon__item accordeon__item_state_active',
	activeGuideSection: 'tabs__tabs-list-section--show'
};

const close = item => item.style.height = '0px';

const updateHeight = forEach(close);

const addHeightActive = forEach(item => {
	const wrap = item.nextElementSibling;
	const height = wrap.querySelector(selectors.content).offsetHeight;

	wrap.style.height = height + 'px';
});


const videoPlayPause = () => {
	const videoClass = '.js--guide-video';
	$(videoClass).each(function () {
		$(this)[0].pause();
	});
	const videoToScroll = () => {
		$(selectors.activeGuideSection).find(videoClass).each(function () {
			const videoHeight = $(this).height();
			const windowHeight = $(window).height();
			const videoTopPos = $(this).offset().top;
			if ((videoTopPos + videoHeight < windowHeight + $(window).scrollTop()) && (videoTopPos + videoHeight / 2 > $(window).scrollTop())) {
				$(this)[0].play();
			} else {
				$(this)[0].pause();
			}
		});
	};
	videoToScroll();
	$(window).on('scroll', function () {
		videoToScroll();
	});
	$(window).on('resize', function () {
		videoToScroll();
	});
};

const clickHandler = e => {
	const el = e.currentTarget;
	const wrap = el.nextElementSibling;
	const parent = el.parentElement;
	const height = wrap.querySelector(selectors.content).offsetHeight;

	findClsRemove(parent, classes.active);
	el.classList.add(classes.active);
	updateHeight(parent.querySelectorAll(selectors.wrap));
	wrap.style.height = height + 'px';
};
const closeCurrent = elem => {
	const parent = elem.parentElement;
	updateHeight(parent.querySelectorAll(selectors.wrap));
	elem.classList.remove(classes.active);
};

const toggle = e => {
	const elem = e.currentTarget;
	const isOpen = elem.classList.contains(classes.active);

	if ($(selectors.commonGuide).length > 0) {
		const target = $(elem).data('target');
		$(selectors.guideSidebarItem).removeClass('active');
		if (!isMobile.phone && !isMobile.tablet) {
			$('html, body').stop().animate({
				scrollTop: $(selectors.quideBlock).offset().top - 50
			}, 1500);
		}
		$(selectors.activeGuideSection).removeClass(classes.activeGuideSection);
		$('#' + target).addClass(classes.activeGuideSection);
		videoPlayPause();
	}

	if (isOpen) {
		closeCurrent(elem);
	} else {
		clickHandler(e);
		$('.js-accordeon').trigger('jsaccordeonclick');
	}
};

const render = () => {
	videoPlayPause();
	updateHeight(document.querySelectorAll(selectors.wrap));
	addHeightActive(document.querySelectorAll('.' + classes.active));
	bindEvent(selectors.target, 'click', toggle);
};

export default render;

